var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "logdetail-container": true, hasTagsView: _vm.needTagsView } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("common.checkDetail"),
            visible: _vm.isVisible,
            "modal-append-to-body": false,
            width: "100%",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isVisible = $event
            },
          },
        },
        [
          _c("el-scrollbar", [
            _c(
              "div",
              _vm._l(_vm.form, function (item, key) {
                return _c(
                  "el-row",
                  { key: key },
                  [
                    _c("el-col", { attrs: { span: 2, offset: 1 } }, [
                      _c("div", { staticClass: "detailIndex" }, [
                        _vm._v(_vm._s(_vm.$t(_vm.lang + ".form." + key))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18, offset: 1 } }, [
                      _vm.isJson(item)
                        ? _c("div", { staticClass: "detailValue json-value" }, [
                            _c("pre", [_vm._v(_vm._s(item.data))]),
                          ])
                        : _c("div", { staticClass: "detailValue" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item) +
                                "\n            "
                            ),
                          ]),
                    ]),
                  ],
                  1
                )
              }),
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }